import { Stack, Typography, Grid, Box } from "@mui/material";
import { ManualInput } from "../../../../utils/form";
import { useManualInputRows } from "../../../../utils/hooks";
import NomenclatureOrderItem from "./NomenclatureOrderItem";
import RemoveButton from "./RemoveButton";
import { NOMENCLATURE_ORDER_CLARIFICATIONS_LABEL } from "../../../homologar/orders/utils/constants";
import { chapterChipFor } from "../chapterDisplay";

/**
 * Order:
 * {
 *   items: { name: string }[],
 *   clarifications: string,
 *   procedureType?: string | null,
 * }
 */

const NomenclatureOrder = ({
  order,
  onChange,
  onRemove,
  onItemRemove,
  form,
  enableRemoveButton,
  fieldRequired,
  orderType,
  isV2,
  ...props
}) => {
  const { control } = form;
  const itemChipSx = (item) =>
    isV2
      ? chapterChipFor({
          chapter: item.chapter,
          procedureType: item.procedureType ?? order.procedureType,
        })?.sx
      : undefined;
  const rows = useManualInputRows();

  return (
    <Grid item xs={12} sm={12} md={6}>
      <Stack
        sx={{
          backgroundColor: "lightBlue.main",
          borderRadius: 3,
          p: 2,
          overflow: "hidden",
        }}
      >
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
              flex: 1,
              mb: 1,
              alignItems: "center",
            }}
          >
            {order.items.length === 0 ? (
              <Typography
                sx={{ fontWeight: 500, color: "secondary.main", fontSize: 12 }}
              >
                Nueva solicitud
              </Typography>
            ) : (
              order.items.map((item) => (
                <NomenclatureOrderItem
                  key={item.procedureId ?? item.name}
                  item={item}
                  onRemove={() => onItemRemove(item)}
                  showRemoveButton={true}
                  chipSx={itemChipSx(item)}
                />
              ))
            )}
          </Box>
          <RemoveButton
            {...props}
            onClick={onRemove}
            disabled={!enableRemoveButton}
            tooltip="Remover orden"
          />
        </Stack>
        <Stack sx={{ mt: 1, mb: 1 }}>
          <ManualInput
            form={form}
            required={fieldRequired}
            value={order.clarifications}
            name="clarifications"
            onChange={(e) => onChange(e.target.value)}
            {...rows}
            label={
              order.items.length === 0
                ? "Solicitud de prácticas"
                : NOMENCLATURE_ORDER_CLARIFICATIONS_LABEL
            }
            sx={{
              "& .MuiInputBase-root": {
                backgroundColor: "#fff",
                borderRadius: 3,
              },
              "& fieldset": {
                borderRadius: 3,
              },
            }}
          />
        </Stack>
      </Stack>
    </Grid>
  );
};

export default NomenclatureOrder;
